import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/developer/ui/inputs")({
    beforeLoad: () => {
        throw redirect({ to: "/design/components/inputs", replace: true });
    },
});
